<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <path class="filled" d="M57.025,34.132l-22.96-22.96a2.921,2.921,0,0,0-4.13,0L6.975,34.132a1.46,1.46,0,0,0,1.032,2.493h4.535V53.052A1.46,1.46,0,0,0,14,54.512H24.973a1.46,1.46,0,0,0,1.46-1.46V38.416a1.46,1.46,0,0,1,1.46-1.46h8.214a1.46,1.46,0,0,1,1.46,1.46V53.052a1.46,1.46,0,0,0,1.46,1.46H50a1.46,1.46,0,0,0,1.46-1.46V36.625h4.535A1.46,1.46,0,0,0,57.025,34.132Z" fill="#304266"/>
    <rect width="64" height="64" fill="none"/>
  </g>
</svg>
